import { apolloHooks } from '@nxte-nl/apollo-hooks';

import { cartV2 } from '../../../queries/cartV2.gql';
import { CartResponse } from '../../../types/apiCompoundCommon';

export const cartV2Hooks = {
  useCartV2Query(setCart: (value: CartResponse | null) => void,
    setIsCartSet: (value: boolean) => void) {
    const [executeRequest, { loading }] = apolloHooks.useLazyQuery<CartResponse>(
      cartV2, { onCompleted: (data: CartResponse) => {
        setCart(data);
        setIsCartSet(true);
      },
      fetchPolicy: 'no-cache',
      },
    );

    return {
      loading,
      executeRequest,
    };
  },
};
